import React from 'react'

import { Field } from 'formik'

import { AiFillTool } from 'react-icons/ai'

import { Form, Col, Button } from '_zari/core'

import * as CategoriaCrud from 'services/categoria.service'

import { CrudCategoriasModal } from 'sharedComponents/modals'

const CategoriaFormGroup = ({ iError, iTouched, fIsSubmitting, values, setValues, handleChange }) => {
  const [categorias, setCategorias] = React.useState([])
  const [mostrarCrudCategoriasModal, setMostrarCrudCategoriasModal] = React.useState(false)

  React.useEffect(() => {
    CategoriaCrud.obtenerAsSelect().then(({ data }) => setCategorias(data))
  }, [])

  const categoriaChangeHandler = React.useCallback(
    e => {
      handleChange(e)
      values._idCategoria = e.target.value
      values._idFamilia = ''
      values._idSubFamilia = ''
      setValues(values)
    },
    [values, setValues, handleChange]
  )

  const refreshCategorias = React.useCallback(() => {
    CategoriaCrud.obtenerAsSelect().then(({ data }) => setCategorias(data))
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='CATEGORÍA' htmlFor='select-categoria' md={3} alignRightAt='md' />
        <Col md={9}>
          <Form.InputGroup>
            <Field name='_idCategoria'>
              {({ field }) => (
                <Form.Select
                  {...field}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  onChange={categoriaChangeHandler}
                  id='select-categoria'
                >
                  <option value=''>Seleccionar</option>
                  {categorias &&
                    categorias.map((val, key) => (
                      <option key={key} value={val._id}>
                        {val.nombre}
                      </option>
                    ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarCrudCategoriasModal(true)} icon>
                <AiFillTool />
              </Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarCrudCategoriasModal && (
        <CrudCategoriasModal
          show={mostrarCrudCategoriasModal}
          handleClose={() => {
            setMostrarCrudCategoriasModal(false)
            refreshCategorias()
          }}
        />
      )}
    </>
  )
}

export default React.memo(CategoriaFormGroup)
